/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCopyFormat = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 23.414.586 15 7.73 7.856l3 1 6.77-6.77L21.914 6.5l-6.77 6.77 1 3zm4.5-7.328.356-.356-1-3 6.23-6.23L17.5 4.914l-6.23 6.23-3-1-.356.356zm-7-4.172L3.414 15 4.5 16.086l2.293-2.293 1.414 1.414L5.914 17.5l.586.586 2.293-2.293 1.414 1.414L7.914 19.5 9 20.586l3.086-3.086z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCopyFormat as CopyFormat };
